import React, { useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Clearfix from "components/Clearfix/Clearfix.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "../../../assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import {
  convertDate,
  isValidUserProfileInputs,
  getUserName,
} from "../../../scripts/util";
import Muted from "../../../components/Typography/Muted";
import {
  CLEAR_ERROR,
  USER_UPDATE_REQUESTED,
  USER_GET_ALL_REQUESTED,
} from "../../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import ReactGA from "react-ga4";
import ImageUpload from "../../../components/CustomUpload/ImageUpload";
import PropTypes from "prop-types";
import CustomLinearProgress from "../../../components/CustomLinearProgress/CustomLinearProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import { SUPER_ADMIN_ROLES, userAccess } from "../../../scripts/const";
import Divider from "@material-ui/core/Divider";
import LocationAutoComplete from "components/LocationAutocomplete/LocationAutocomplete.js";
import CustomTextArea from "components/CustomInput/CustomTextArea.js";

const useStyles = makeStyles(styles);

export default function EditUser(props) {
  const { roleId: currentRoleId } = useSelector(
    (state) => state.login.loginUser.detail
  );

  const [error, setError] = React.useState(false);
  const [userId, setUserId] = React.useState(false);
  const [validationErrMsg, setValidationErrMsg] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [user, setUser] = React.useState({});

  const handleSelect = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.value,
    });
  };

  const handleCheckBox = (e) => {
    setUser({
      ...user,
      [e.target.name]: e.target.checked,
    });
  };
  const dispatch = useDispatch();

  const editError = useSelector((state) => state.user.userUpdateError);
  const editProgress = useSelector((state) => state.user.userUpdateFetching);
  const editSuccess = useSelector((state) => state.user.userUpdateSuccess);
  const allUsers = useSelector((state) => state.user.users);

  function clearErrors() {
    setValidationErrMsg("");
  }

  useEffect(() => {
    setModalOpen(props.open);
  }, [props.open]);

  useEffect(() => {
    if (!modalOpen) {
      clearErrors();
      // setUser({});
    }
  }, [modalOpen]);

  useEffect(() => {
    setValidationErrMsg("");
    dispatch({ type: CLEAR_ERROR });
  }, []);

  useEffect(() => {
    setUser(props.user);
    setUserId(props.user.id);
  }, [props.user]);

  useEffect(() => {
    setError(editError);
  }, [editError]);

  useEffect(() => {
    setSuccess(editSuccess);
  }, [editSuccess]);

  useEffect(() => {
    if (editSuccess === true) {
      setTimeout(() => {
        props.handleSuccess(false);
      }, 730);
      dispatch({ type: USER_GET_ALL_REQUESTED });
      setTimeout(() => {
        setUser({});
        dispatch({ type: CLEAR_ERROR });
      }, 731);
    }
  }, [editSuccess]);

  function editUser() {
    const errors = isValidUserProfileInputs(user);
    if (errors.length > 0) {
      setValidationErrMsg(errors);
      dispatch({ type: CLEAR_ERROR });
    } else {
      setValidationErrMsg("");
      dispatch({
        type: USER_UPDATE_REQUESTED,
        payload: { payload: user, id: userId },
      });
    }
  }

  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem
          style={{
            textAlign: "center",
            marginTop: 40,
          }}
          xs={12}
          sm={12}
          md={12}
        >
          <ImageUpload isNew user={props.user} avatar />
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody className="d-flex flex-column gap-3">
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  {validationErrMsg && (
                    <SnackbarContent
                      message={validationErrMsg}
                      color="warning"
                    />
                  )}
                  {error && (
                    <SnackbarContent
                      message="Something went wrong."
                      color="warning"
                    />
                  )}
                  {editProgress && <CustomLinearProgress color="primary" />}
                  {success && (
                    <SnackbarContent
                      message="Updated the user"
                      color="success"
                    />
                  )}
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="ID"
                    id="editUser-id"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: userId || "",
                      disabled: true,
                      name: "id",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Email address"
                    id="editUser-email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: user.email || "",
                      disabled: true,
                      name: "email",
                      type: "email",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Phone Number *"
                    id="editUser-phone"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: user.phone || "",
                      onChange: handleSelect,
                      name: "phone",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="First Name *"
                    id="editUser-firstName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: user.firstName || "",
                      onChange: handleSelect,
                      name: "firstName",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Last Name *"
                    id="editUser-lastName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: user.lastName || "",
                      onChange: handleSelect,
                      name: "lastName",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <LocationAutoComplete
                    defaultValue={user.address}
                    onPlaceSelected={(value) =>
                      handleSelect({
                        target: {
                          name: "address",
                          value: value?.display_name,
                        },
                      })
                    }
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Role
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={user.roleId || ""}
                      onChange={handleSelect}
                      inputProps={{
                        name: "roleId",
                        id: "roleId",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classes.selectMenuItem,
                        }}
                      >
                        Choose Role
                      </MenuItem>
                      {SUPER_ADMIN_ROLES.includes(currentRoleId) && (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value="1"
                        >
                          Super Admin
                        </MenuItem>
                      )}
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="2"
                      >
                        Manager
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="3"
                      >
                        General
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="4"
                      >
                        Accountant
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="5"
                      >
                        Lead Generator
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelText="Password"
                    id="editUser-password"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      type: "password",
                      onChange: handleSelect,
                      name: "password",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classes.selectLabel}
                    >
                      Status
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={`${user.isActive}` || ""}
                      onChange={handleSelect}
                      inputProps={{
                        name: "isActive",
                        id: "isActive",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classes.selectMenuItem,
                        }}
                      >
                        Select Status
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="true"
                      >
                        Active
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="false"
                      >
                        Inactive
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomTextArea
                    labelText="Detail"
                    id="update-user-detail"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      multiline: true,
                      value: user.detail || "",
                      rows: 3,
                      onChange: handleSelect,
                      name: "detail",
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer
                style={{
                  display: "flex",
                  backgroundColor: "rgb(72 119 143)",
                  padding: "20px",
                  borderRadius: "25px",
                  marginTop: "10px",
                }}
              >
                <GridItem xs={12} sm={12} md={12}>
                  <h4>Appointment Setting</h4>
                  <Divider />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <div className={classes.checkboxAndRadio}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={user["onlineAppointment"] || false}
                          onChange={handleCheckBox}
                          name={"onlineAppointment"}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot,
                      }}
                      label={"Online Appointment"}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <div className={classes.checkboxAndRadio}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={user["isPaid"] || false}
                          onChange={handleCheckBox}
                          name={"isPaid"}
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot,
                          }}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot,
                      }}
                      label={"Is Paid?"}
                    />
                  </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelProps={{ color: "secondary" }}
                    labelText="Paid Amount ($)"
                    id="paidAmount-id"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: !user["isPaid"],
                      value: user["paidAmount"] || "",
                      name: "paidAmount",
                      onChange: handleSelect,
                      type: "number",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelProps={{ color: "secondary" }}
                    labelText="Slot Time (Default 30)"
                    id="slotTime-id"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: user["slotTime"] || "",
                      name: "slotTime",
                      onChange: handleSelect,
                      type: "number",
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <CustomInput
                    labelProps={{ color: "secondary" }}
                    labelText="Appointment Note"
                    id="appointmentNote"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: user["appointmentNote"] || "",
                      name: "appointmentNote",
                      onChange: handleSelect,
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer
                style={{
                  display: "flex",
                  backgroundColor: "#B0BEC5",
                  padding: "20px",
                  borderRadius: "25px",
                  marginTop: "10px",
                }}
              >
                <GridItem xs={12} sm={12} md={12}>
                  <h4>Additional Access</h4>
                  <Divider />
                </GridItem>
                {userAccess.map((access, id) => {
                  const { label, name } = access;
                  return (
                    <GridItem key={id} xs={12} sm={12} md={3}>
                      <div className={classes.checkboxAndRadio}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={user[name] || false}
                              onChange={handleCheckBox}
                              name={name}
                              checkedIcon={
                                <Check className={classes.checkedIcon} />
                              }
                              icon={<Check className={classes.uncheckedIcon} />}
                              classes={{
                                checked: classes.checked,
                                root: classes.checkRoot,
                              }}
                            />
                          }
                          classes={{
                            label: classes.label,
                            root: classes.labelRoot,
                          }}
                          label={label}
                        />
                      </div>
                    </GridItem>
                  );
                })}
              </GridContainer>
              <br />
              <br />
              <Button
                color="primary"
                disabled={editProgress}
                className={classes.moveToRight}
                onClick={(e) => {
                  e.preventDefault();
                  ReactGA.event({
                    category: "User",
                    action: "Updated a User",
                  });
                  editUser();
                }}
              >
                Update
              </Button>
              <Muted>Updated At: {convertDate(user.updatedAt)}</Muted>
              <Muted>Updated By: {getUserName(user.updatedBy, allUsers)}</Muted>
              <Clearfix />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

EditUser.propTypes = {
  user: PropTypes.object,
};
